import Link from 'next/link'
import { clsx } from 'shared/libs/style-merge'

import { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react'

import { Loader } from '../loader'

import styles from './Button.module.scss'

export type Variant = 'primary' | 'accent' | 'supportive' | 'additional'

export interface ButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  variant?: Variant
  loading?: boolean
  leftIcon?: ReactNode
  href?: string
  rightIcon?: ReactNode
  loadingIconSize?: number
  replace?: boolean
  fullWidth?: boolean
}

export function Button({
  loading = false,
  children,
  type = 'button',
  variant = 'primary',
  className,
  disabled,
  leftIcon,
  href,
  rightIcon,
  loadingIconSize = 20,
  fullWidth = false,
  replace = false,
  ...props
}: ButtonProps) {
  if (href) {
    return (
      <Link
        href={href}
        className={clsx(
          styles.button,
          variant && [styles[variant]],
          fullWidth && styles.fullWidth,
          className,
        )}
        replace={replace}
      >
        {loading ? (
          <div className={styles.loader}>
            <Loader
              iconColor={variant === 'accent' ? '#fff' : '#01974B'}
              iconSize={loadingIconSize}
            />
          </div>
        ) : (
          children
        )}
        {leftIcon && leftIcon}
      </Link>
    )
  }
  return (
    <button
      className={clsx(
        styles.button,
        variant && [styles[variant]],
        fullWidth && styles.fullWidth,
        className,
      )}
      type={type}
      disabled={disabled || loading}
      {...props}
    >
      {leftIcon && leftIcon}
      {loading ? (
        <div className={styles.loader}>
          <Loader
            iconColor={variant === 'accent' ? '#fff' : '#01974B'}
            iconSize={loadingIconSize}
          />
        </div>
      ) : (
        children
      )}
      {rightIcon && rightIcon}
    </button>
  )
}
